import React from "react";
import { ProcessedQuoteFeed } from "../../../store/types";
import { Label } from "@fluentui/react-components";

export const quoteFeeds = (quoteFeeders: ProcessedQuoteFeed[]) => {
  return quoteFeeders.map((quoteFeed) => {
    if (quoteFeed[0] === "None") return null;

    return (
      <li key={quoteFeed[1]}>
        <Label>{quoteFeed[0]}</Label>
      </li>
    );
  });
};
